module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"tabs":{"life":"Min Profil","week":"Ukentlig hjerte","follow":"Interesser","team":"Team","results":"Team challenge"}},"en":{"tabs":{"life":"Overview","week":"Weekly Heart","follow":"Following Lifeskills","team":"Team Progress","results":"Team activity/history"}}}')
  delete Component.options._Ctor
}
